<template>
  <v-menu offset-y left v-if="auth" open-on-click close-on-click :close-on-content-click="false" v-model="menu">
    <template v-slot:activator="{ on, attrs }">
    <!--<router-link v-if="auth" :to="{name: 'settings'}">-->
      <v-list color="transparent" class="pa-0">
        <v-list-item-action v-on="on" v-bind="attrs" class="mr-0">
        <!--<v-list-item-action class="mr-0">-->
          <v-list-item class="text-right pa-0">
            <!--<v-list-item-content>-->
              <!--<v-list-item-title>{{auth.name +' '+((auth.last_name) ? auth.last_name : '')}}</v-list-item-title>-->
              <!--<v-list-item-subtitle>{{auth.email}}</v-list-item-subtitle>-->
            <!--</v-list-item-content>-->

            <div class="wrap-img" :class="(auth.pro) ? 'user-pro-img' : ''">
              <div class="block-img">
                  <img v-if="auth.photo && typeof auth.photo == 'object'" :src="auth.photo[40]" />
                  <img v-else-if="auth.photo" :src="auth.photo" />
                  <span v-else class="photo" :style="{'background': auth.bg_color}">{{auth.name.substr(0,1)}}</span>
              </div>
              <div class="online"></div>
            </div>
          </v-list-item>
        </v-list-item-action>
      </v-list>
    <!--</router-link>-->
    </template>

    <v-list class="modal-profile">
      <!--<div>-->
        <!--<p>-->
          <!--<v-icon width="10" height="10" class="green&#45;&#45;text" name="check"></v-icon>Your identity has been verified-->
        <!--</p>-->
      <!--</div>-->
          <div class="block-profile">
              <div class="wrap-img">
                <router-link :to="{name: 'home', params: {lang: $store.getters.getLang}}" class="block-img">
                  <!--<img v-if="auth.photo" :src="auth.photo" />-->
                  <!--<span class="photo" :style="{'background': auth.bg_color}">{{auth.name.substr(0,2)}}</span>-->
                  <span class="photo">{{auth.name.substr(0,2)}}</span>
                </router-link>
              </div>
              <router-link :to="{name: 'home', params: {lang: $store.getters.getLang}}" class="block-right">
                  <span class="profile-title" :class="(auth.pro) ? 'user-pro' : ''">{{auth.name +' '+((auth.last_name) ? auth.last_name : '')}}</span>

<!--                  <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path d="M0.181416 0.180506C-0.0601215 0.42155 -0.0604924 0.812694 0.18052 1.05426L6.58423 7.47128C6.82512 7.7122 6.82509 8.10412 6.58376 8.34547L0.18052 14.762C-0.0605233 15.0036 -0.0601215 15.3947 0.181416 15.6358C0.422954 15.8768 0.814129 15.8764 1.05514 15.6349L7.45795 9.21877C7.81935 8.85731 8 8.38267 8 7.90796C8 7.43353 7.81941 6.95902 7.45839 6.59802L1.05514 0.181403C0.814129 -0.0601044 0.422954 -0.0605068 0.181416 0.180506Z" fill="currentColor"/>-->
<!--                  </svg>-->
              </router-link>

              <div class="block-ref">
                  <input type="text" :value="auth.ref_link" ref="myInput">
                  <span class="profile-subtitle" @click="copyLink">
                     <span>@{{(auth.public_id) ? auth.public_id : auth.id}}</span>
                     <p v-if="submitSuccess">{{__('Copied')}}</p>
                  </span>
              </div>

<!--              <v-btn  text class="btn-link ml-4 btn-theme" v-ripple="false" @click="changeTheme">-->
<!--                  <svg  v-if="theme == 'dark'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>-->

<!--                  <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path d="M7.99911 13.3556C7.69758 13.3556 7.45312 13.6 7.45312 13.9015V15.4539C7.45312 15.7554 7.69758 15.9999 7.99911 15.9999C8.30072 15.9999 8.5451 15.7554 8.5451 15.4539V13.9015C8.5451 13.5999 8.30065 13.3556 7.99911 13.3556Z" fill="currentColor"/>-->
<!--                      <path d="M7.99911 2.64468C8.30072 2.64468 8.5451 2.40022 8.5451 2.09869V0.546199C8.5451 0.24467 8.30072 0.000213623 7.99911 0.000213623C7.69758 0.000213623 7.45312 0.24467 7.45312 0.546199V2.09869C7.45312 2.40022 7.69758 2.64468 7.99911 2.64468Z" fill="currentColor"/>-->
<!--                      <path d="M3.44098 11.7867L2.34289 12.8842C2.12959 13.0973 2.12952 13.4431 2.34267 13.6563C2.44932 13.7629 2.58909 13.8163 2.72886 13.8163C2.86856 13.8163 3.00819 13.763 3.11484 13.6565L4.21293 12.559C4.42622 12.3458 4.4263 12.0001 4.21314 11.7869C3.99985 11.5736 3.6542 11.5736 3.44098 11.7867Z" fill="currentColor"/>-->
<!--                      <path d="M12.1724 4.37274C12.3121 4.37274 12.4518 4.31945 12.5585 4.21288L13.6564 3.11538C13.8696 2.90215 13.8697 2.55651 13.6565 2.34321C13.4433 2.12991 13.0977 2.12984 12.8844 2.34313L11.7864 3.44064C11.5732 3.65379 11.5731 3.99951 11.7863 4.21273C11.8929 4.31945 12.0326 4.37274 12.1724 4.37274Z" fill="currentColor"/>-->
<!--                      <path d="M2.64432 8.00012C2.64432 7.69859 2.39986 7.45413 2.09833 7.45413H0.545986C0.244456 7.45413 0 7.69859 0 8.00012C0 8.30165 0.244456 8.5461 0.545986 8.5461H2.09833C2.39986 8.5461 2.64432 8.30165 2.64432 8.00012Z" fill="currentColor"/>-->
<!--                      <path d="M15.454 7.45413H13.901C13.5994 7.45413 13.355 7.69859 13.355 8.00012C13.355 8.30165 13.5994 8.5461 13.901 8.5461H15.454C15.7556 8.5461 16 8.30165 16 8.00012C16 7.69866 15.7556 7.45413 15.454 7.45413Z" fill="currentColor"/>-->
<!--                      <path d="M3.44102 4.21292C3.54759 4.31949 3.68737 4.37278 3.82707 4.37278C3.96677 4.37278 4.10654 4.31949 4.21312 4.21292C4.42634 3.99969 4.42634 3.65397 4.21312 3.44075L3.11561 2.34324C2.90238 2.13001 2.55667 2.13001 2.34351 2.34324C2.13029 2.55646 2.13029 2.90218 2.34351 3.11534L3.44102 4.21292Z" fill="currentColor"/>-->
<!--                      <path d="M12.5591 11.7868C12.3459 11.5736 12.0002 11.5735 11.7869 11.7867C11.5736 11.9999 11.5736 12.3457 11.7869 12.5588L12.8842 13.6563C12.9909 13.763 13.1306 13.8163 13.2703 13.8163C13.41 13.8163 13.5498 13.763 13.6564 13.6564C13.8697 13.4432 13.8697 13.0975 13.6565 12.8843L12.5591 11.7868Z" fill="currentColor"/>-->
<!--                      <path d="M7.99969 3.7504C5.65654 3.7504 3.75024 5.65683 3.75024 8.00013C3.75024 10.3434 5.65654 12.2497 7.99969 12.2497C10.3431 12.2497 12.2495 10.3434 12.2495 8.00013C12.2495 5.65683 10.343 3.7504 7.99969 3.7504ZM7.99969 11.1577C6.25865 11.1577 4.84222 9.74124 4.84222 8.00013C4.84222 6.25895 6.25865 4.84237 7.99969 4.84237C9.74095 4.84237 11.1575 6.25895 11.1575 8.00013C11.1575 9.74124 9.74095 11.1577 7.99969 11.1577Z" fill="currentColor"/>-->
<!--                  </svg>-->
<!--              </v-btn>-->
          </div>


      <div class="wrap-modal-btn"
           v-for="item in profile_nav_list"
           :key="item.name"

      >
          <v-list-item
            v-ripple="false"
            v-on:click="(item.url) ? sendAjax(item.url) : ''"
            :to="(item.route) ? {name: item.route, params: {current: (item.params) ? item.params : null, lang: $store.getters.getLang}} : null"
            :exact="true"
            @click="menu = false"
          >
              <img :src="'/dist/images/frontend/'+item.icon" />
              <img class="img-hover" :src="'/dist/images/frontend/'+item.icon_hover" />
              {{__(item.name)}}
          </v-list-item>
      </div>

        <v-menu
            v-if="languages && active_language"
            v-model="languages_menu"
            open-on-hover
            min-width="195"
            max-width="195"
            offset-x
            left
        >
            <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs" class="block-lang">
                    <div class="block-lang__left">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.2581 1H6.96774V3.90323H8.12903V2.16129H16.2581C16.6065 2.16129 16.8387 2.39355 16.8387 2.74194V9.12903C16.8387 9.47742 16.6065 9.70968 16.2581 9.70968H8.70968V13.7742H5.63226L3.48387 15.4581V13.7742H1.74194C1.39355 13.7742 1.16129 13.5419 1.16129 13.1935V6.80645C1.16129 6.45806 1.39355 6.22581 1.74194 6.22581H9.29032V5.06452H1.74194C0.754839 5.06452 0 5.81936 0 6.80645V13.1935C0 14.1806 0.754839 14.9355 1.74194 14.9355H2.32258V17.8968L5.98065 14.9355H9.87097V10.871H16.2581C17.2452 10.871 18 10.1161 18 9.12903V2.74194C18 1.75484 17.2452 1 16.2581 1Z" fill="currentColor"/>
                            <path d="M2.43945 12.5548H3.833L4.18139 11.6258H5.98139L6.32978 12.5548H7.72332L5.74913 7.38708H4.35558L2.43945 12.5548ZM5.05236 8.8387L5.633 10.6387H4.47171L5.05236 8.8387Z" fill="currentColor"/>
                            <path d="M10.4512 9.12904C11.0899 9.12904 11.9608 8.95485 12.7738 8.54839C13.5867 8.95485 14.5157 9.12904 15.0963 9.12904V7.96775C15.0963 7.96775 14.5157 7.96775 13.877 7.73549C14.5738 7.03872 15.0963 5.99356 15.0963 4.48388V3.90323H13.3544V2.74194H12.1931V3.90323H10.4512V5.06452H13.877C13.7608 6.10969 13.2963 6.74839 12.7738 7.15485C12.4254 6.86452 12.077 6.45807 11.8447 5.93549H10.6254C10.8576 6.69033 11.206 7.27098 11.6705 7.73549C11.0899 7.96775 10.5673 7.96775 10.4512 7.96775V9.12904Z" fill="currentColor"/>
                        </svg>

                        <p>{{__('Language')}}</p>
                    </div>

                    <span>{{active_language.full_lang}}</span>
                </div>
            </template>
            <div class="block-all-lang">
                <div
                    class="lang-item"
                    v-for="(language, key) in languages"
                    :key="key"
                    v-on:click="selectLanguages(language.lang)"
                    :class="(language.lang == active_language.lang) ? 'active' : ''"
                >
<!--                    <img :src="'/dist/images/flags/'+language.lang+'.png'"/>-->
                    <p>{{language.full_lang}}</p>
                </div>
            </div>
        </v-menu>

        <div class="wrap-modal-btn"
             v-for="item in profile_nav_list_bottom"
             :key="item.name"

        >
            <v-list-item
                    v-ripple="false"
                    v-on:click="(item.url) ? sendAjax(item.url) : ''"
                    :to="(item.route) ? {name: item.route, params: {current: (item.params) ? item.params : null, lang: $store.getters.getLang}} : null"
                    :exact="true"
                    @click="menu = false"
            >
                <img :src="'/dist/images/frontend/'+item.icon" />
                <img class="img-hover" :src="'/dist/images/frontend/'+item.icon_hover" />
                {{__(item.name)}}
            </v-list-item>
        </div>

      <svg v-if="auth.verified == 1" class="status-verification" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.25 9.375L7.5 11.625L12.75 6.375" stroke="#01DF72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 16.5C13.1422 16.5 16.5 13.1422 16.5 9C16.5 4.85775 13.1422 1.5 9 1.5C4.85775 1.5 1.5 4.85775 1.5 9C1.5 13.1422 4.85775 16.5 9 16.5Z" stroke="#01DF72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <svg v-else-if="auth.verified == 2" class="status-verification" width="10" height="18" viewBox="0 0 38 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M33.19 66.2685H32.9647V53.7047C32.9647 51.1729 31.9586 48.7938 30.1294 47.002C29.795 46.6729 29.4577 46.3855 29.0972 46.1204C26.5053 44.2207 22.1584 40.3879 22.1584 36.0706C22.1584 31.7528 26.5053 27.9205 29.0966 26.0192C29.4555 25.7546 29.7927 25.4672 30.1294 25.1392C31.9551 23.3482 32.963 20.9689 32.963 18.4365L32.9636 5.87272H33.1877C35.5463 5.87272 37.4653 3.5988 37.4653 0.80292C37.467 0.438129 37.1644 0.141846 36.7913 0.141846H0.775303C0.402767 0.141846 0.100191 0.438129 0.100191 0.80292C0.100191 3.59866 2.01864 5.87272 4.37666 5.87272H4.60189V18.4365C4.60189 20.9678 5.60859 23.3475 7.43602 25.1392C7.77102 25.4672 8.10886 25.7546 8.46889 26.0197C11.0602 27.9199 15.4071 31.7522 15.4071 36.0701C15.4071 40.3868 11.0602 44.2202 8.46889 46.1221C8.11001 46.385 7.77274 46.6724 7.4366 47.0021C5.60858 48.7931 4.60131 51.1729 4.60131 53.7048V66.2685H4.37607C2.01806 66.2685 0.0996094 68.5425 0.0996094 71.3383C0.0996094 71.7031 0.402185 71.9994 0.774721 71.9994H36.7907C37.1633 71.9994 37.4658 71.7031 37.4658 71.3383C37.4664 68.5426 35.5474 66.2685 33.1894 66.2685L33.19 66.2685ZM4.37687 4.54956C2.93849 4.54956 1.74076 3.21515 1.49615 1.46354H36.0707C35.8261 3.21506 34.6283 4.54956 33.1911 4.54956H4.37687ZM31.6146 5.87226V13.5268C27.6958 14.5822 23.2749 15.1457 18.7828 15.1457C14.2891 15.1457 9.86926 14.5821 5.95287 13.5251V5.87226H31.6146ZM8.39257 24.203C6.81993 22.6619 5.95316 20.6136 5.95316 18.436V14.8945C9.89634 15.9215 14.3065 16.4672 18.7831 16.4672C23.2592 16.4672 27.6705 15.9203 31.6149 14.8945V18.436C31.6149 20.6142 30.7492 22.6621 29.1754 24.203C28.8871 24.4854 28.5959 24.7349 28.2893 24.9599C27.5676 25.489 26.8185 26.0855 26.0848 26.7382C23.3395 29.0618 20.9517 30.1939 18.7853 30.1939C16.6207 30.1939 14.229 29.0611 11.4871 26.7377C10.7533 26.0872 10.0037 25.4896 9.28366 24.961C8.97369 24.7349 8.68079 24.4865 8.39242 24.2031L8.39257 24.203ZM8.39257 47.9359C8.68093 47.6536 8.97327 47.4041 9.27868 47.1807C12.6913 44.6784 16.7572 40.7193 16.7572 36.0699C16.7572 34.109 16.0292 32.2733 14.9366 30.6153C16.2641 31.2196 17.5318 31.5153 18.7825 31.5153C20.0349 31.5153 21.3028 31.219 22.6296 30.6153C21.5376 32.2739 20.8096 34.109 20.8096 36.0699C20.8096 40.7176 24.8774 44.6784 28.2876 47.179C28.5958 47.4057 28.887 47.6541 29.1754 47.9359C30.7492 49.4774 31.6148 51.5253 31.6148 53.7034V56.898C28.5139 53.0686 23.8592 50.838 18.7842 50.838C13.7093 50.838 9.05456 53.0686 5.95368 56.898V53.7034C5.95368 51.5259 6.81932 49.4774 8.39251 47.9359L8.39257 47.9359ZM5.95374 59.197C8.7276 54.7872 13.5113 52.1613 18.7843 52.1613C24.059 52.1613 28.841 54.7872 31.6149 59.197V66.2678H5.95403L5.95374 59.197ZM1.49702 70.6765C1.74102 68.9256 2.93996 67.5905 4.37775 67.5905H33.1908C34.6292 67.5905 35.8259 68.9255 36.0704 70.6765H1.49702ZM18.7843 43.5646C19.1568 43.5646 19.4594 43.8609 19.4594 44.2257C19.4594 44.5905 19.1568 44.8868 18.7843 44.8868C18.4118 44.8868 18.1092 44.5905 18.1092 44.2257C18.1092 43.8609 18.4118 43.5646 18.7843 43.5646ZM18.7843 39.3765C19.0328 39.3765 19.2342 39.5748 19.2342 39.8181C19.2342 40.061 19.0328 40.2587 18.7843 40.2587C18.5358 40.2587 18.3344 40.0604 18.3344 39.8181C18.3344 39.5742 18.5358 39.3765 18.7843 39.3765ZM18.7843 35.1199C18.9475 35.1199 19.0795 35.2491 19.0795 35.409C19.0795 35.5688 18.9475 35.698 18.7843 35.698C18.6211 35.698 18.4891 35.5688 18.4891 35.409C18.4891 35.2491 18.6211 35.1199 18.7843 35.1199ZM18.7843 47.7523C19.2814 47.7523 19.6846 48.1466 19.6846 48.6339C19.6846 49.1212 19.2814 49.5161 18.7843 49.5161C18.2878 49.5161 17.884 49.1218 17.884 48.6345C17.884 48.1477 18.2878 47.7523 18.7843 47.7523Z" fill="#FDAE02"/>
      </svg>

      <svg v-else class="status-verification" width="18" height="18" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M70.9035 36C70.9035 55.2763 55.277 70.9038 35.9996 70.9038C16.7222 70.9038 1.0957 55.2773 1.0957 36C1.0957 16.7226 16.7222 1.09607 35.9996 1.09607C55.277 1.09607 70.9035 16.7226 70.9035 36Z" stroke="#FF4B55" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M20.7549 20.7546L51.2456 51.2454" stroke="#FF4B55" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M20.7549 51.2454L51.2456 20.7546" stroke="#FF4B55" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
      </svg>

        <BaseButton
            v-if="!auth.pro"
            class="mt-3"
            class_btn="btn-guest"
            :to="{name:'buy_premium', params: {lang: $store.getters.getLang}}"
        >
            <span style="font-weight: 600">
                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M13.939 4.40257L18.7783 2.78943C19.4652 2.56051 20.13 3.1894 19.9395 3.88798L17.22 13.8595C17.1124 14.2538 16.7542 14.5275 16.3454 14.5275H3.65451C3.24574 14.5275 2.8875 14.2538 2.77989 13.8595L0.0604297 3.88798C-0.130098 3.1894 0.534733 2.56051 1.22163 2.78943L6.06095 4.40257L9.29202 0.36353C9.65492 -0.0900893 10.3449 -0.0900893 10.7078 0.36353L13.939 4.40257ZM2.25519 5.04505L4.34676 12.7146H15.6531L17.7446 5.04505L13.9127 6.32243C13.5524 6.44251 13.1554 6.32521 12.9181 6.02872L9.99988 2.38085L7.08164 6.02872C6.84437 6.32519 6.44739 6.44248 6.08705 6.32243L2.25519 5.04505Z" fill="white"/>
                </svg>
                {{__('Subscribe Pro')}}
            </span>
        </BaseButton>
    </v-list>
  </v-menu>
  <div v-else>{{__('loading')}}</div>
</template>

<script>
import BaseButton from "./BaseButton";
import store from "../../store";
export default {
    name: "LayoutNavProfile",


  data: function () {
    return {
      profile_nav_list: [
        {
          name: "Deposit / Withdrawal",
          icon: "icon-deposit-nav.svg",
          icon_hover: "icon-deposit-nav-hov.svg",
          route: "balances_current",
        },

        {
          name: "Верификация",
          icon: "icon-verification-nav.svg",
          icon_hover: "icon-verification-nav-hov.svg",
          route: "settings_current",
          params: "verification",
        },

        {
          name: "Settings and Security",
          // name: "Account Settings",
          icon: "icon-settings-nav.svg",
          icon_hover: "icon-settings-hov.svg",
          route: "settings",
        },
        {
            name: "Affiliate Program",
            icon: "icon-affilProgram-nav.svg",
            icon_hover: "icon-affilProgram-hov.svg",
            route: "affiliate",
        },

        {
          name: "Support",
          icon: "icon-support-nav.svg",
          icon_hover: "icon-support-hov.svg",
          route: "chat",
          params: "support",
        }
      ],
      profile_nav_list_bottom: [
          // {
          //     name: "To developers",
          //     icon: "icon-toDevelopers-nav.svg",
          //     icon_hover: "icon-toDevelopers-hov.svg",
          //     route: "developers",
          // },

          {
              name: "Log Out",
              icon: "icon-logout-nav.svg",
              icon_hover: "icon-logout-hov.svg",
              url: "ajax/logout",
          },
      ],
      menu: false,
      submitSuccess: false,
      languages_menu: false,
      active_languages: null,
    };
  },
  methods: {
      selectLanguages: function (event) {
          let response= {
              lang: event
          };

          if(event != this.lang) {
              let params = this.$cleanObject(this.$route.params);
              if(this.$route.name== 'profile' || this.$route.name== 'home') {
                  if(this.languages.map(function (e) { return String(e['lang']); }).indexOf(String(event)) < 0 && params.lang && !params.id) {
                      params['id'] = params.lang;
                  }
              }
              params['lang'] = (event == 'ru') ? null :event;

              store.commit("updateLanguage", event);
              this.$router.push({ name: this.$route.name, params: params });
              this.languages_menu = false;

              this.$http.post("ajax/set_locale", response)
                  .then((response) => {
                      return response.json();
                  })
                  .then((response) => {
                      this.$checkAuth(response)
                      // if(this.$checkAuth(response)) {
                      // }
                      this.menu = false;
                  })
                  .catch((err) => {
                      this.httpHandler(err);
                  })
          }
          this.$emit('ListenScroll');
      },
      getLanguage: function (event) {
          let languages = this.languages;

          let language = languages.filter((item) => {
              return item.lang == event;
          });
          return language.length ? language[0] : languages[0];
      },
    sendAjax: function (url) {
      this.$http
        .get(url)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
            if(this.$checkAuth(response)) {
                if (url == "ajax/logout") {
                    this.$router.push({name: 'home', params: {lang: this.$store.getters.getLang}});
                    location.reload();
                }
            }
        })
        .catch((err) => {
          this.httpHandler(err);
        });
    },

    changeTheme() {
      let template = (this.theme == 'dark') ? 'white' : 'dark';
      this.$store.commit("updateTheme", template);
      localStorage.template = template;
    },

    copyLink() {
        let copyText = this.$refs.myInput;
        copyText.select();
        document.execCommand("copy");

        this.submitSuccess=true;

        setTimeout(()=> {
            this.submitSuccess= null;
        }, 2000);
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth.user;
    },
    theme() {
      return this.$store.getters.getTheme;
    },
      languages() {
          return this.$store.state.language.list;
      },
      getLang() {
          return this.$store.getters.getLang;
      },
      lang() {
          return this.$store.getters.getLanguage;
      },
  },
    asyncComputed: {
        active_language() {
            let language = this.$store.state.language.lang,
                languages = this.languages;

            if (language && languages) {
                return this.getLanguage(language);
            } else {
                return null;
            }
        },
    },
  components: {
    BaseButton
  }
};
</script>

<style lang="scss" scoped>
// .menuable__content__active {
//   top: 81px !important;
// }
.dark .theme--light.v-list {
    background: #10111b;
    /*border: 1px solid #2B2B2B;*/
    box-sizing: border-box;
    box-shadow: none;
}

.dark .theme--light.v-list-item:hover:before {
    opacity: 0;
}

.dark .theme--light.v-list .theme--light.v-list-item {
    color: #96AFD1!important;
}

.dark .img-hover {
    filter: invert(0%) sepia(100%) saturate(0%) hue-rotate(119deg) brightness(900%) contrast(105%);
}

.dark .modal-profile {
    box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.35);
    .block-profile {
        border-bottom: 2px solid #2B2B2B;
        .profile-title {
            color: #fff;
        }

        .block-img {
            .photo {
                background: rgba(38, 169, 244, 0.15);
                color: #fff;
            }
        }

        .block-right {
            svg {
                color: #96AFD1;
            }
        }

        .btn-link {
            svg {
                color: #F3F7FE;
            }
        }
    }

    .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: #96AFD1 !important;

        &:hover {
            color: #fff!important;
            background: transparent;
        }
    }

    .theme--light.v-list-item--active {
        background: #181818;
    }

    .theme--light.v-list-item--active:before, .theme--light.v-list-item--active:hover:before, .theme--light.v-list-item:focus:before {
        opacity: 0;
    }

    .wrap-modal-btn {
        /*&:nth-child(7) {*/
        /*    border-top: 2px solid #2B2B2B;*/
        /*}*/
    }
}

.block-all-lang {
    margin-right: 25px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: #181818;
    box-shadow: 0 3px 23px 0px rgba(255, 255, 255, 0.10) !important;
    max-width: 170px;

    .lang-item.active {
        background-color: #2B2B2B;
    }

    .lang-item {
        height: 40px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        &:hover {
            background-color: #2B2B2B;
        }

        p {
            color: #FFF;
            font-size: 14px;
            font-weight: 400;
            margin: 0;
        }
    }
}

.online {
  background: #00C569;
  border: 1px solid #111D38;
  box-sizing: border-box;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  position: absolute;
  right: 0;
  bottom: 2px;
}

.v-list-item__content > :not(:last-child) {
  margin-bottom: 0;
}

.v-list-item {
  margin: 16px 0 16px 15px;
  min-height: fit-content;

  &__content {
    padding: 0 0 0 30px;
    display: block;
  }

  .wrap-img {
    position: relative;
    /*margin-left: 10px;*/
  }

  .block-img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    /*width: 40px;*/
    /*height: 40px;*/
    /*border-radius: 50%;*/

    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      /*  width: 40px;*/
      /*  height: 40px;*/
      /*  border-radius: 8px;*/
    }

    .photo {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      /*  width: 40px;*/
      /*  height: 40px;*/
      /*  border-radius: 50%;*/
      display: flex;
      color: #FFFFFF;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      font-size: 18px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  &__title {
    max-width: 135px;
    width: 100%;
    margin: 0;
    font-size: 14px!important;
    line-height: 19px;
    color: #000000;
    /*font-size: 14px;*/
    /*line-height: 19px;*/
    /*color: #002b50;*/
    text-align: right;
    letter-spacing: 0.01em;
    font-weight: 400;
    text-overflow: ellipsis;
  }

  &__subtitle {
    max-width: 135px;
    width: 100%;
    font-size: 12px;
    line-height: 16px;
    color: #646464!important;
    text-align: right;
    letter-spacing: 0.01em;
    /*color: #96afd1;*/
    text-overflow: ellipsis;
  }

  &__action {
      -ms-flex-item-align: center;
      align-self: center;
       /*margin: 12px 0;*/
      padding: 0;
      /*margin: 0;*/
  }

  &__avatar {
    box-shadow: 0 2px 24px rgba(0, 0, 0, 0.05);
  }
}

.theme--light.v-list-item .v-list-item__action-text,
.theme--light.v-list-item .v-list-item__subtitle {
  color: #96afd1;
}

.modal-profile {
  padding: 20px 20px 20px;
  width: 320px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  position: relative;

    .status-verification {
        position: absolute;
        top: 142px;
        right: 22px;
    }


    .block-profile {
        display: flex;
        align-items: center;
        padding-bottom: 18px;
        margin-bottom: 10px;
        border-bottom: 2px solid #F3F7FE;
        width: 100%;
        position: relative;
        .wrap-img {
          position: relative;
          margin-right: 10px;
        }

    .block-img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      /*width: 40px;*/
      /*height: 40px;*/
      /*border-radius: 50%;*/

      img {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        /*  width: 40px;*/
        /*  height: 40px;*/
        /*  border-radius: 8px;*/
      }

      .photo {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        /*  width: 40px;*/
        /*  height: 40px;*/
        /*  border-radius: 50%;*/
        background: rgba(38, 169, 244, 0.15);
        display: flex;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #002b50;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        text-transform: uppercase;
      }
    }

    .block-right {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        svg {
            color: #002B50;
            transition: .3s;
        }

        &:hover {
            svg {
                color: #0F9AFF;
                transition: .3s;
            }

            .profile-title {
                color: #0F9AFF;
                text-decoration: underline;
                transition: .3s;
            }
        }
    }

        .btn-link {
            margin-right: -16px;

            svg {
                color: #002b50;
            }
        }

    .profile-title {
      font-size: 12px;
      line-height: 16px;
      color: #002b50;
      display: block;
      transition: .3s;
      margin-bottom: 21px;
    }

      .block-ref {
          position: absolute;
          bottom: 20px;
          left: 50px;
      }

    .profile-subtitle {
      font-size: 12px;
      line-height: 16px;
      color: #26A9F4;
      cursor: pointer;
      margin-top: -18px;
      position: relative;
      display: flex;
      align-items: center;
      width: fit-content;

        &:hover {
            span {
                text-decoration: underline;
            }
        }

        p {
            margin: 0 0 0 20px;
            font-size: 12px;
            line-height: 16px;
            color: #6886AF;
            border: none;
            text-decoration: none;
        }
    }

      input {
          opacity: 0;
          cursor: default;
      }
  }

  /*p {*/
    /*color: #96afd1;*/
    /*font-size: 14px;*/
    /*line-height: 19px;*/
    /*padding:0 10px 20px;*/
    /*border-bottom: 2px solid #f0f6fe;*/
    /*margin-bottom: 10px;*/

    /*svg {*/
      /*margin-right: 14px;*/
    /*}*/
  /*}*/

    .block-lang {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid #2B2B2B;
        margin-bottom: 10px;
        padding-bottom: 10px;
        height: 50px;

        &__left {
            display: flex;
            align-items: center;

            svg {
                margin-right: 10px;
                color: #6886AF;
            }

            p {
                color: #96AFD1;
                font-size: 14px;
                font-weight: 500;
                margin: 0;
                padding: 0;
                border: none;
            }
        }

        span {
            display: block;
            color: #26A9F4;
            text-align: right;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }

        &:hover {
            .block-lang__left {
                svg {
                    color: #fff;
                }

                p {
                    color: #fff;
                }
            }
        }
    }

    .wrap-modal-btn {
        /*&:nth-child(7) {*/
        /*    border-top: 2px solid #F3F7FE;*/
        /*    margin-top: 10px;*/
        /*    padding-top: 10px;*/
        /*}*/
    }

    .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: #6886AF !important;

        &:hover {
            color: #002B50!important;
        }
    }

  .v-list-item {
    min-height: 40px;
    border-radius: 6px;
    padding: 0;
    color: #6886AF!important;
    margin: 0;

      img {
          margin-right: 10px;
          width: 18px;
          height: 18px;
      }

      .img-hover {
          display: none;
      }

    &:hover {
      background-color: transparent;
      color: #002B50!important;

        img {
            display: none;
        }
        .img-hover {
            display: block;
        }
    }
  }
}

.v-menu__content {
  position: absolute;
  display: inline-block;
  max-width: 80%;
  overflow-y: auto;
  overflow-x: hidden;
  contain: content;
  will-change: transform;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  margin-top: -16px;
}

.v-menu__content--fixed {
  position: fixed;
  margin-right: 0;
  margin-top: -12px;
}

.v-list-item--link:before {
  background-color: #f0f6fe;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.v-list-item--active {
  background-color: transparent;
  color: #002B50!important;
}

@media screen and (max-width: 1124px) {
  .v-list-item {
    &__content {
      padding: 0 0 0 15px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .v-list-item {

    &__content {
      padding: 0 0 0 15px;
    }
    &__title {
      font-size: 12px;
    }

    &__subtitle {
      font-size: 10px;
    }

    &__avatar {
      height: 32px;
      min-width: 32px;
      width: 32px;
    }

    &__action {
      -ms-flex-item-align: center;
      align-self: center;
      /* margin: 12px 0; */
      padding: 12px 0;
      margin: 0;
    }

    &__avatar {
      box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);
    }
  }

  .modal-profile {
    padding: 15px 15px 20px;
    /*width: 280px;*/

      .status-verification {
          top: 137px;
      }

    p {
      padding-bottom: 15px;
      margin-bottom: 15px;
    }
  }
  .v-menu__content--fixed {
    margin-top: -10px;
  }
}

@media screen and (max-width: 768px) {
  .modal-profile {
    /*font-size: 12px;*/
    width: 230px;
    padding: 15px;

      .status-verification {
          top: 132px;
      }

    p {
      color: #96afd1;
      font-size: 12px;
      line-height: 17px;
      padding-bottom: 15px;
      border-bottom: 2px solid #f0f6fe;
      margin-bottom: 10px;

      svg {
        margin-right: 10px;
      }
    }

    .v-list-item {
      min-height: 35px;
      border-radius: 6px;
      margin-bottom: 2px;
      padding: 0;

      &:hover {
        background-color: #f0f6fe;
      }
    }



    /*img {*/
    /*  margin-right: 7px;*/
    /*  width: 15px;*/
    /*  height: 15px;*/
    /*}*/
  }
  .modal-profile {
      width: 275px;
  }

}

@media screen and (max-width: 500px) {
    .modal-profile {
        .v-list-item {
            padding: 0!important;
        }
    }
}
@media screen and (max-width: 450px) {
  .v-list-item {
    margin: 16px 0 16px 10px;
    &__title {
      max-width: 75px;
    }

    &__subtitle {
      max-width: 75px;
    }
  }
}

/*@media screen and (max-width: 475px) {*/
  /*.v-list-item {*/

    /*&__title {*/
      /*max-width: 80px;*/
    /*}*/

    /*&__subtitle {*/
      /*max-width: 80px;*/
    /*}*/

    /*.wrap-img {*/
      /*margin-left: 3px;*/
    /*}*/

    /*.block-img {*/
      /*width: 30px;*/
      /*height: 30px;*/
      /*border-radius: 50%;*/

      /*img {*/
        /*width: 30px;*/
        /*height: 30px;*/
        /*border-radius: 50%;*/
      /*}*/
    /*}*/
    /*&__content {*/

      /*padding: 0 0 0 10px;*/
    /*}*/

    /*&__title {*/
      /*font-size: 10px;*/
    /*}*/

    /*&__subtitle {*/
      /*font-size: 8px;*/
    /*}*/
  /*}*/

  /*.modal-profile {*/
    /*font-size: 10px;*/
    /*width: 200px;*/
    /*padding: 10px;*/

    /*p {*/
      /*color: #96afd1;*/
      /*font-size: 10px;*/
      /*line-height: 17px;*/
      /*padding-bottom: 10px;*/
      /*border-bottom: 2px solid #f0f6fe;*/
      /*margin-bottom: 5px;*/

      /*svg {*/
        /*margin-right: 10px;*/
      /*}*/
    /*}*/

    /*.v-list-item {*/
      /*min-height: 30px;*/
      /*border-radius: 6px;*/
      /*padding: 0 9px;*/
      /*margin-bottom: 2px;*/

      /*&:hover {*/
        /*background-color: #f0f6fe;*/
      /*}*/
    /*}*/

    /*img {*/
      /*margin-right: 7px;*/
      /*width: 13px;*/
      /*height: 13px;*/
    /*}*/
  /*}*/
/*}*/
</style>
